import { apiGet } from '../api.ts'
import { useQuery } from '@tanstack/react-query'
import { QueryCacheKeys } from '@/api/queryKeys.ts'
import { DISABLE_ALERTS_LIVE_FETCHING } from '@/constant/constant.ts'
import { MINUTE } from '@/constant/time.ts'

export const apiGetEmergencyLiveAlert = async () => {
    return await apiGet<IResGetEmergencyLive>(`/alert/emergency/live`)
}

const useQueryGetUrgentNotification = (enabled = false) => {
    return useQuery({
        enabled: enabled && !DISABLE_ALERTS_LIVE_FETCHING,
        queryKey: QueryCacheKeys.notification.getEmergencyAlertLive(),
        // 배회감지 중심이므로 긴급알림은 2분마다 확인 (기존 1초에서 변경)
        refetchInterval: 2 * MINUTE,
        queryFn: async () => {
            const { data } = await apiGetEmergencyLiveAlert()
            return data
        }
    })
}

export default useQueryGetUrgentNotification

export interface IResGetEmergencyLive {
    emergencies: IAlertEmergencyLiveItem[];
}

export interface IEmergenciesProtectee {
    id: number;
    name: string;
}

export interface IEmergenciesAlert {
    createdAt: string;
    taskManagerAt: string;
    isMyTask: boolean;
    type?: EmergencyAlertType;
    confirm?: string;
}

export enum EmergencyAlertType {
    SOS = 'sos',
    FALL = 'fall'
}

export interface IAlertEmergencyLiveItem {
    id: number;
    protectee: IEmergenciesProtectee;
    alert: IEmergenciesAlert;
}
